import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {Link, LinkIcon, GetStartedInput} from '../../components'
import Styles from './Media.css'
import container from '../../helpers/container'
import ReactPlayer from 'react-player'
import {SlideDown} from 'react-slidedown'

@CSSModules(Styles, {allowMultiple:true})
export default class Media extends Component {
  constructor(props) {
    super(props)
    this.state = {
      releaseLaunch: false
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  pressHits = [
    {
      outlet: 'Marketplace',
      headline: 'Looking at wealth management through a "gender lens"',
      link: 'https://www.marketplace.org/2019/01/09/your-money/more-investment-firms-investors-are-applying-gender-lens-wealth-building'
    },
    {
      outlet: 'Quartz',
      headline: 'This tool is an easy way to check if your investments support gender equality',
      link: 'https://qz.com/1461617/as-you-sow-checks-how-well-mutual-funds-promote-gender-equality/'
    },
    {
      outlet: "Barron's",
      headline: 'Just How Gender-Equity Focused Is That Fund, Anyway?',
      link: 'https://www.barrons.com/articles/just-how-gender-equity-focused-is-that-fund-anyway-1542126101'
    },
    {
      outlet: 'Fast Company',
      headline: 'This tool helps you make sure your 401(k) is supporting gender equality',
      link: 'https://www.fastcompany.com/90263635/this-tool-helps-you-make-sure-your-401k-is-supporting-gender-equality'
    },
    {
      outlet: 'U.S. News and World Report',
      headline: 'How to Find Gender Equality Mutual Funds and ETFs',
      link: 'https://money.usnews.com/investing/funds/articles/how-to-find-gender-equality-mutual-funds-and-etfs'
    },
    {
      outlet: 'Financial Advisor Magazine',
      headline: 'New Tool Applies Gender Diversity Screen To Mutual Fund, ETF Holdings',
      link: 'https://www.fa-mag.com/news/a-gender-lens-now-can-be-applied-to-investments-41832.html'
    }
  ]

  clickViewMore = (release) =>{
    const newState = {}
    newState[release] = !this.state[release]
    this.setState(newState)
  }

  renderReleaseLaunch = () => {
    return (
      <div styleName='release-wrap'>

        <div styleName='press-release-title'>New Gender Lens Investing Tool Helps Drive Capital to Mutual Funds Supporting Gender Equality</div>

        <p><strong>As You Sow is gearing up to release its fifth Invest Your Values screening tool, Gender Equality Funds</strong></p>

        <p><strong>Oakland, California &mdash; Nov. 13 2018 &mdash;</strong> As You Sow is gearing up to release its fifth Invest Your Values screening tool, Gender Equality Funds, on Nov. 13. Gender Equality Funds is a free, online tool that enables individual and institutional investors to apply a gender lens to mutual fund and ETF investments.</p>

        <p>Gender Equality Funds screens the specific holdings of about 5,000 of the most commonly-held U.S. mutual funds—including financial giants like Vanguard, BlackRock, and State Street—against a database detailing individual company performance on 12 key gender equality performance indicators. These 12 indicators measure policies that demonstrate a commitment to gender diversity and gender balance in the overall leadership, management, and workforce of companies, combining into an overall gender equality portfolio score for each mutual fund.</p>

        <SlideDown>
          { this.state.releaseLaunch ? (
            <div>
              <p>This transparency gives investors, for the first time, the ability to apply a gender lens in evaluating mutual funds. It encourages fund managers to construct and offer investment vehicles that are sympathetic to gender parity, ultimately exerting market pressure on companies to improve their performance on gender issues.</p>

              <p>“This tool could not be coming out at a better time,” Andrew Behar, CEO of As You Sow, said. “Women comprise 47 percent of the workforce, but only 4.8 percent of S&P 500 companies have female CEOs. The new tool empowers investors to see what is hidden within the mutual funds that comprise the bulk of their retirement savings and 401(k) plans. The first step is to know what you own — then you can use the power of your capital to invest in companies that have policies and practices that promote gender equality. We expect this tool to unleash a tsunami of change in the way women are treated in the workforce.”</p>

              <p>Gender Equality Funds enables investors to align their investment with their values. It reveals which mutual funds are investing in the companies that lead the field in terms of gender balance and equality. Investors can easily search the Gender Equality Funds database to see how specific funds are scored, find responsible options that track leading companies in terms of gender equality, and compare financial returns.</p>

              <p>“I am thrilled to see As You Sow launching this gender lens tool,” Kristin Hull, founder and CEO of Nia Impact Capital, said. “We at Nia know the benefit to companies and investors of being gender smart. My hope is that advisors and investors across the country will utilize this new way to assess mutual funds.”</p>

              <p>Gender Equality Funds sources mutual fund holdings data from Morningstar and company-specific gender data from Equileap, the leading organization providing data and insights on gender equality in the corporate sector. With Gender Equality Funds, you’ll see at a glance whether mutual funds are investing in companies that are prioritizing gender equality.</p>

              <p>“Impact investing should not be limited to private deals or customized public portfolios,” Ruth Shaber, founder and president of Tara Health Foundation, said. “The bulk of the wealth in this country is invested in mutual funds. If we want to democratize access to impact investing, we need to create tools for everyone, from individuals with 401(k)s to institutional investors with billions of dollars under management. The Gender Equality Funds tool allows anyone to apply a gender lens to their investments.”</p>

              <p>Gender Equality Funds is As You Sow’s fifth Invest Your Values online tool, joining Fossil Free Funds, Deforestation Free Funds, Tobacco Free Funds, and Weapon Free Funds.</p>
            </div>
          ) : null }
        </SlideDown>
        <div styleName='release-btn-cntr'>
          <button
            styleName='release-btn'
            onClick={() => this.clickViewMore('releaseLaunch')}
          >
            { this.state.releaseLaunch ? (
              <span>Show less<LinkIcon faclass='fa-angle-up'/></span>
            ) : (
              <span>Show more<LinkIcon faclass='fa-angle-down'/></span>
            ) }
          </button>
        </div>
      </div>
    )
  }

  render() {
    const title = 'Media'
    const description = ''
    const url = config.domain + config.routes.media

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='anchor' id='top'/>
              <div styleName='title'>{title}</div>
              <div styleName='answers'>

                { /* primary contact link */ }
                <div styleName='answer'>
                  <div styleName='anchor' id='contact'/>
                  <div styleName='answer-title'>
                    Get in touch
                    &nbsp;&mdash;&nbsp;
                    <Link
                      xstrong={true}
                      styleName='contact'
                      to={config.links.contact}
                      title='Contact form'>
                      Contact us<LinkIcon faclass='fa-envelope-o' />
                    </Link>
                  </div>
                </div>

                { /* webinar recording */ }
                <div styleName={'answer webinar-answer'} >
                  <div styleName='anchor' id='webinar'/>
                  <div styleName='answer-title'>
                    Webinar video
                  </div>

                  <div styleName='media-react-player-wrap'>
                    <ReactPlayer
                      url='https://vimeo.com/302518828'
                      volume={0.5}
                    />
                  </div>
                </div>

                { /* press releases */ }
                <div styleName='answer' >
                  <div styleName='anchor' id='release'/>
                  <div styleName='answer-title'>
                    Press release
                  </div>

                  {this.renderReleaseLaunch()}

                </div>

                { /* press coverage */ }
                <div styleName='answer' >
                  <div styleName='anchor' id='press'/>
                  <div styleName='answer-title'>
                    Media coverage
                  </div>
                  <div styleName='answer-info'>
                    {this.pressHits.map( (pressHit, i) => {
                      return (
                        <div key={i} styleName='press-item'>
                          <Link
                            to={pressHit.link}
                            title={pressHit.outlet + ' - ' + pressHit.headline}>
                            <div styleName='press-item-outlet'>
                              {pressHit.outlet}
                            </div>
                            <div>{pressHit.headline}<LinkIcon /></div>
                          </Link>
                        </div>
                      )
                    })}
                  </div>
                </div>

                { /* email links for comms and general info */ }
                <div styleName='answer'>
                  <div styleName='anchor' id='contact'/>
                  <div styleName='answer-title'>
                    Media + General inquiries
                  </div>
                  <div styleName='answer-info'>
                    <p><strong>Media</strong></p>
                    <p>Stefanie Spear, Communications Director, Gender Equality Funds</p>
                    <p>
                      <Link
                        xstrong={true}
                        styleName='contact'
                        to={config.links.contactStefanie}
                        title='Email Stefanie Spear, Communications Director, Gender Equality Funds'>
                        Email<LinkIcon />
                      </Link>
                    </p>
                    <br/>
                    <p><strong>General</strong></p>
                    <p>Andrew Montes, Director of Digital Strategies, As You Sow</p>
                    <p>
                      <Link
                        xstrong={true}
                        styleName='contact'
                        to={config.links.contactAndrew}
                        title='Email Andrew Montes, Director of Digital Strategies, As You Sow  '>
                        Email<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>

              </div>

            </div>
          </div>

          <GetStartedInput />

        </div>
      </div>
    )
  }
}